import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import EditStudentDialog from './EditStudentDialog'; // Adjust import path
import { COUNTRY_CODES } from '../../utils/countryCodes.js';
import { studentValidation } from './utils/editStudentValidation';
import { buildFullPhoneNumber, extractPhoneParts } from './utils/phoneNumberUtil';

function EditStudent(props) {
    const [open, setOpen] = useState(false);
    const [student, setStudent] = useState({});
    const [errors, setErrors] = useState({});

    const handleClickOpen = () => {
        const studentData = props.data.row;
        
        // Initialize student state with data
        const initializedStudent = Object.keys(studentData).reduce((acc, key) => {
            if (key !== '_links') {
                acc[key] = studentData[key] !== undefined ? studentData[key] : '';
            }
            return acc;
        }, {});

        
       const { phoneAreaCode, phoneNumber } = extractPhoneParts(initializedStudent.phoneNumber);

        setStudent({
            ...initializedStudent,
            phoneAreaCode,
            phoneNumber
        });

        
        setOpen(true);
        setErrors({});
    };

    const handleClose = () => setOpen(false);

    const handleChange = (event) => {
        const { name, value } = event.target;
        let newValue = value;

        // Apply input restrictions
        switch (name) {
            case 'firstName':
            case 'lastName':
                newValue = value.replace(/[^a-zA-Z\s'-]/g, '');
                if (newValue.length > 50) newValue = newValue.substring(0, 50);
                break;
            case 'phoneNumber':
                newValue = value.replace(/[^\d\s()x-]/g, '');
                if (newValue.length > 20) newValue = newValue.substring(0, 20);
                break;
            case 'email':
            case 'studentAddress':
            case 'classes':
            case 'notes':
                if (newValue.length > 255) newValue = newValue.substring(0, 255);
                break;
            default:
                break;
        }

        setStudent(prev => ({ ...prev, [name]: newValue }));
        
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
    };

    const handlePhoneAreaCodeChange = (e) => {
        setStudent(prev => ({ ...prev, phoneAreaCode: e.target.value }));
    };

    const validateFields = () => {
        const validationErrors = {};
        
        Object.keys(studentValidation).forEach(field => {
            const rules = studentValidation[field];
            const value = student[field]?.trim() || '';
            
            if (rules.required && !value) {
                validationErrors[field] = rules.required;
            } else if (rules.pattern && !rules.pattern.value.test(value)) {
                validationErrors[field] = rules.pattern.message;
            } else if (rules.maxLength && value.length > rules.maxLength.value) {
                validationErrors[field] = rules.maxLength.message;
            } else if (rules.minLength && value.length < rules.minLength.value) {
                validationErrors[field] = rules.minLength.message;
            }
        });
        
        return validationErrors;
    };

    const handleSave = () => {
        const validationErrors = validateFields();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const fullPhoneNumber = buildFullPhoneNumber(student.phoneAreaCode, student.phoneNumber);

        props.updateStudent(
            { ...student, phoneNumber: fullPhoneNumber },
            props.data.id
        );

        handleClose();
    };
    

    return (
        <div>
            <IconButton onClick={handleClickOpen}>
                <EditIcon color="primary" />
            </IconButton>
            
            <EditStudentDialog
                open={open}
                onClose={handleClose}
                student={student}
                errors={errors}
                countryCodes={COUNTRY_CODES}  // Pass country codes
                onFieldChange={handleChange}
                onPhoneAreaCodeChange={handlePhoneAreaCodeChange}
                onSave={handleSave}
            />
        </div>
    );
}

export default EditStudent;